// Define the types of fields that can appear on a form step
export type OptionType = {
  id: string
  label: string
  disabled?: boolean
}

export enum FieldType {
  BUTTONS_CHECKBOX = 'buttonsCheckbox',
  BUTTONS_RADIO = 'buttonsRadio',
  SUBMIT = 'submit',
  RADIO = 'radio',
  SELECT = 'select',
  CHECKBOX = 'checkbox',
  TEXT = 'text',
  EMAIL = 'email',
  TEL = 'tel',
  TEXTAREA = 'textarea',
  CONSENT = 'consent',
  NUMBER = 'number',
  PASSWORD = 'password',
}

export type FieldConfig = {
  id: string
  fieldType: FieldType
  options?: OptionType[]
  label?: string
  placeholder?: string
  required?: boolean
  width?: FieldConfigWidthValue
  linkText?: string
  linkUrl?: string
  fieldClassName?: string
  minLength?: number
  customValidationMessage?: string
  loading?: boolean
  variant?: string
  autoFocus?: boolean
  readOnly?: boolean
}

export enum FieldConfigWidth {
  FULL = 'full',
  HALF = 'half',
}

// Type alias for backward compatibility
export type FieldConfigWidthValue = FieldConfigWidth | 'full' | 'half'

export type SectionType = {
  id?: string
  title?: string
  fields: FieldConfig[]
}

// Define the structure for each step
export type StepConfig = {
  title: string
  subtitle: string
  description?: string
  maxSelections?: number
  sections: SectionType[]
}

// Field processor function type for dynamic field modification
export type FieldProcessor = (sections: SectionType[], formData: Record<string, any>) => SectionType[]

// Define the overall form configuration
export type MultiStepFormConfig = {
  steps: StepConfig[]
  fieldProcessor?: FieldProcessor
}

// Form status
export enum FormStatus {
  FILLING = 'filling',
  SUCCESS = 'success',
}
